import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import SideMenu from "./SideMenu";
import Footer from "./Footer";
import Header from "./Header";
import Logout from "./Logout";
import { strings } from "../Utilities/strings";
import Loader from "../Utilities/Loader";
import * as XLSX from "xlsx";
// for Sidebar And Navbar
//for fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Add_Icon from "../images/Add_Icon.svg";

import {
  faEdit,
  faTrash,
  faPlus,
  faDeleteLeft,
} from "@fortawesome/free-solid-svg-icons";
//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import Login from "../Login";
import {
  deleteActivity,
  FarmOperation_getMasters,
  rmActivity,
  RmhistoryGet,
} from "../Utilities/URLCONSTANTS";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import closedProducts from "../images/closed-products.png";
import user from "../images/user.png";
import productrequestImage from "../images/product_request.png";
import issuedProducts from "../images/issued-products.png";
import PendingProducts from "../images/Pending_products.png";
// import Delete from "../images/ic_delete.png";
import Delete from "../images/deleat_icon.svg";
import Edit_Icon from "../images/edit_icon.svg";
import { date } from "yup";
import moment from "moment";
import { CustomDatePickerInput, customstyles, modalCustomStyles } from "../Utilities/utils";
import Select from "react-select";
import searchIcon from "../images/search_icon.svg";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from "../Utilities/Pagination";

//ProductMaster

const FarmOperationsSprayServices = ({ }) => {
  const [loaderImage, setLoaderImage] = useState(
    require("../images/fo_loader.gif")
  );
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  const [id, setId] = useState("");
  const [selectedLocation, setSelectedLocation] = useState({
    code: "",
    name: "",
  });
  const [locationDropDownData, setlocationDropDownData] = useState([]);
  const [selectedSparyer, setSelectedSparyer] = useState({
    code: "",
    name: "",
  });
  const [sparyerDropDownData, setsparyerDropDownData] = useState([]);
  const [selectedDropdownData, setSelectedDropdownData] = useState();
  const [serviceId, setServiceId] = useState("");
  const [date, setDate] = useState("");
  const [SprayersID, setSprayersID] = useState("");
  const [spares, setSpares] = useState("");
  const [fuel, setfuel] = useState("");
  const [cost, setCost] = useState("");
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState("");
  const [errorService, setErrorService] = useState("");
  const [Errorlocation, setErrorlocation] = useState("");
  const [ErrorSprayersID, setErrorSprayersID] = useState("");
  const [Errorspares, setErrorSpares] = useState("");
  const [Errorfuel, setErrorfuel] = useState("");
  const [errorcost, setErrorCost] = useState("");
  const [errorremarks, setErrorRemarks] = useState("");
  const [errorDate, setErrorDate] = useState("");
  const [buttonText, setButtonText] = useState("Submit");
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState(
    "Do you want to close Spray Service"
  );
  const [showMsg, setShowMsg] = useState("false");
  ///modal popup
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    id: "",
    activityType: "",
    requiredDate: "",
    locationId: "",
    locationName: "",
    service: "",
    SprayersID: "",
    repair: "",
    cost: "",
    remarks: "",
    submittedDate: "",
  });

  const [data, setData] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState("");
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const handleCancel_new = () => {
    setShowModal(true);
    setShowPopup(true);
  };
  const [filteredData, setFilteredData] = useState([]); // For filtered results
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState();
  const [getActivityType, setGetActivityType] = useState([]);

  // const totalItems = filteredData.length;
  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data != null && data != undefined) {
      const filteredResults = data.filter(
        (item) => {
          return (
            item.submittedDate.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.sprayerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.locationName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.service.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.spares.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.fuel
              .toString()
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            item.cost
              .toString()
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            item.remarks.toLowerCase().includes(searchTerm.toLowerCase())
          )
        });
      setFilteredData(filteredResults);
      handlePageClick(1)
    }
  };

  useEffect(() => {
    if (data != null && data != undefined) {
      //  const totalItems = data.length;
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  const pageNumbers = [];
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    pageNumbers.push(i);
  }

  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const exportToExcel = () => {
    const data = [
      [
        "S.no",
        "Date",
        "SprayersID",
        "Location",
        "Service",
        "Spares",
        "Fuel(in Liters)",
        "Cost",
        "Remarks",
      ], // Custom headers
      // ...currentItems.map((item) => [
      ...filteredData.map((item, index) => [
        index + 1,
        item.submittedDate,
        // item.sprayerId,sprayerName
        item.sprayerName,
        item.locationName,
        item.service,
        item.spares,
        item.fuel,
        item.cost,
        item.remarks,
      ]),
    ];
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SprayServices");
    // Save the file
    XLSX.writeFile(wb, "SprayServices.xlsx");
  };

  const handleCancel = () => {
    //no
    setShowModal(true);
    setShowPopup(false);
  };
  const handleClose = () => {
    //yes
    setShowPopup(false);
    setShowModal(false);
  };

  // ...more items

  function handlelocationChange(e) {
    const selectedValue = e.target.value;
    const selectedLocationData = locationDropDownData.find(
      (item) => item.code.toString() === selectedValue
    );
    console.log(JSON.stringify(locationDropDownData));
    if (selectedLocationData) {
      setSelectedLocation({
        code: selectedLocationData.code,
        name: selectedLocationData.name,
      });
      // Filter the sprayers based on the selected location's code
      const filteredSprayers = selectedDropdownData.sprayersMaster.filter(
        (item) => item.locationId.toString() === selectedValue
      );
      setsparyerDropDownData(filteredSprayers);
    } else {
      setSelectedLocation({
        code: "",
        name: "",
      });
    }
  }
  const handleServiceChange = (e) => {
    const input = e.target.value;
    const result = input.replace(/[^a-z_\s]/gi, "");
    setServiceId(result);
  };
  const handleSprayersIDChange = (e) => {
    const selectedValue = e.target.value;
    const selectedspayerData = sparyerDropDownData.find(
      (item) => item.code.toString() === selectedValue
    );
    console.log(JSON.stringify(sparyerDropDownData));
    if (selectedspayerData) {
      setSelectedSparyer({
        code: selectedspayerData.code,
        name: selectedspayerData.name,
      });
    } else {
      setSelectedSparyer({
        code: "",
        name: "",
      });
    }
  };
  const handledateChange = (e) => {
    const selectedDate = e.target.value;
    setDate(selectedDate);
  };
  const parseLocalDate = (dateString) => {
    if (!dateString) return null;

    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  };
  const handleSparesChange = (e) => {
    const inputSpares = e.target.value;
    setSpares(inputSpares);
  };
  const handlefuelChange = (e) => {
    const inputfuel = e.target.value;
    if (!isNaN(inputfuel)) {
      setfuel(inputfuel);
    }
  };
  const handleCostChange = (e) => {
    const inputunitCost = e.target.value;
    if (!isNaN(inputunitCost)) {
      setCost(inputunitCost);
    }
  };
  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };

  const handleresponse = () => {
    setShowResponsePopup(false);
    setShowWarningPopup(false);
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handleSubmit = async (modalData) => {
    if (date === "") {
      // setErrorDate('Please Enter Date');
      alert("Please Enter Date");
      return;
    }
    if (selectedLocation.code === "") {
      // setErrorlocation('Please Select a Location');
      alert("Please Select a Location");
      return;
    }
    if (selectedSparyer.code === "") {
      //setErrorSprayersID('Please Enter SprayersID');
      alert("Please Enter SprayersID");
      return;
    }
    if (serviceId === "") {
      //  setErrorlocation('Please Select a Location');
      alert("Please Enter Service");
      return;
    }

    if (spares === "") {
      // setErrorSpares('Please Enter Spares');
      alert("Please Enter Spares");
      return;
    }
    if (fuel === "") {
      // setErrorfuel('Please Enter a fues');
      alert("Please Enter Fuel");
      return;
    }

    if (cost === "") {
      // setErrorCost('Please Enter Cost');
      alert("Please Enter Cost");
      return;
    }

    try {
      console.log(
        ":::::::::" +
        cost +
        " : " +
        spares +
        " : " +
        remarks +
        " : " +
        selectedSparyer.code +
        " : " +
        date +
        " : " +
        serviceId +
        " : " +
        selectedLocation.code +
        ":" +
        fuel
      );
      // Check if required fields are not empty
      if (
        cost !== "" &&
        spares !== "" &&
        selectedSparyer.code !== "" &&
        date !== "" &&
        serviceId !== "" &&
        selectedLocation.code !== "" &&
        fuel !== ""
      ) {
        const apiUrl = rmActivity;
        const headers = await GetApiHeaders();
        // alert(buttonText);
        const dataToSend = {
          serverRecordId: { buttonText } == "Submit" ? 0 : parseInt(id),
          activityType: getActivityType[4].name,
          requiredDate: moment.utc(date).format("YYYY-MM-DD HH:mm:ss.SSS"), //moment(date, "YYYY-MM-DD HH:mm:ss.SSS") ,//date,
          locationId: selectedLocation.code,
          locationName: selectedLocation.name,
          service: serviceId,
          sprayerId: selectedSparyer.code, //parseInt(SprayersID)
          spares: spares,
          cost: parseInt(cost),
          remarks: remarks,
          fuel: fuel,
          submittedDate: moment.utc(date).format("YYYY-MM-DD HH:mm:ss.SSS"), //moment(date, "YYYY-MM-DD HH:mm:ss.SSS")  //date
        };
        // Make the POST request using Axios with headers
        setIsLoading(true);
        const response = await axios.post(apiUrl, dataToSend, { headers });
        console.log("response submit:: ", response);
        setsubmitResponse(response.data.message);
        setShowModal(false);
        setShowResponsePopup(true);
        setIsLoading(false);

        // Proceed with data insertion if the API call was successful
        const newId = String(Date.now());
        const newItem = {
          id: newId,
          activityType: "generalMaintenance",
          requiredDate: date,
          locationId: selectedLocation.code,
          locationName: selectedLocation.name,
          service: serviceId,
          SprayersID: selectedSparyer.code, //SprayersID,
          spares: spares,
          cost: cost,
          remarks: "",
          submittedDate: "",
          serverRecordId: "",
          fuel: fuel,
        };
        setErrorCost("");
        setErrorDate("");
        setErrorSprayersID("");
        setErrorRemarks("");
        setErrorSpares("");
        setfuel("");
        setErrorService("");
        setErrorlocation("");
        setIsSubmitted(true);
        //setData(prevData => [...prevData, newItem]);
      } else {
        setIsSubmitted(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsSubmitted(false);
      //  handleUpdate();
    }
  };

  const fetchData = async () => {
    const apiUrl = RmhistoryGet;
    const headers = await GetApiHeaders();
    const getDataObject = {
      activityType: "sprayers",
      endDate: "",
      mobileNumber: headers.mobileNumber,
      startDate: "",
      userId: headers.userId,
    };

    setIsLoading(true);
    axios
      .post(apiUrl, getDataObject, { headers })
      .then((response) => {
        console.log(
          "main table response ::;;",
          JSON.stringify(response.data.response.rmHistory)
        );
        setData(response.data.response.rmHistory);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      });
  };
  //for data table
  const tableRef = useRef(null);
  useEffect(() => {
    // Check if DataTable is already initialized
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      // Destroy the existing DataTable instance
      $(tableRef.current).DataTable().destroy();
    }

    // Initialize the DataTable
    $(tableRef.current).DataTable({
      ordering: false, // Disable sorting
    });
    fetchData();
    fetchLocationDropdownData();
  }, [modalData]);

  const handleModalOpen = () => {
    setButtonText("Submit");
    setIsSubmitted(false);
    setIsUpdated(false);
    setShowModal(true);
    setId(0);
    setSelectedLocation({ code: "", name: "" });
    setSelectedSparyer({ code: "", name: "" });
    setServiceId("");
    setSprayersID("");
    setSpares("");
    setfuel("");
    setCost("");
    setRemarks("");
    setDate("");
    setModalData({
      id: "",
      activityType: "",
      requiredDate: "",
      locationId: "",
      locationName: "",
      service: "",
      SprayersID: "",
      repair: "",
      cost: "",
      remarks: "",
      submittedDate: "",
      serverRecordId: "",
    });
  };

  const handleModalClose = () => {
    setShowPopup(false);
    setShowModal(false);

    setShowWarningPopup(false);
    window.location.reload();
  };
  const fetchLocationDropdownData = async () => {
    const apiUrl = FarmOperation_getMasters;
    const headers = await GetApiHeaders();
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        console.log("response", response);
        setSelectedDropdownData(response.data.response);
        setlocationDropDownData(response.data.response.subSiteMaster);
        setsparyerDropDownData(response.data.response.sprayersMaster);
        setGetActivityType(response.data.response.rmActivitiesMaster);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const deleteItem = async (item) => {
    // alert(JSON.stringify(item));
    const apiUrl = deleteActivity;
    const headers = await GetApiHeaders();

    const dataToSend = {
      id: item.serverRecordId,
    };
    setIsLoading(true);
    const response = await axios.post(apiUrl, dataToSend, { headers });
    console.log("response submit:: ", response);
    setsubmitResponse(response.data.message);
    setShowResponsePopup(true);
    setIsLoading(false);
  };

  const updatedItems = (item) => {
    setModalData(item);
    setId(item.serverRecordId);
    setDate(
      item.submittedDate !== "" && item.submittedDate !== null
        ? item.submittedDate.toString().split(" ")[0]
        : ""
    );
    setSelectedLocation({ code: item.locationId, name: item.locationName });
    setSelectedSparyer({ code: item.sprayerId });
    setServiceId(item.service);
    setSprayersID(item.sprayerId);
    setSpares(item.spares);
    setfuel(item.fuel);
    setCost(item.cost);
    setRemarks(item.remarks);
    setShowModal(true);
    setButtonText("Update");
    setIsSubmitted(false);
    setIsUpdated(false);
  };
  const closeWarning = () => {
    setShowWarningPopup(true);
  };
  const setMinDateToToday = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };


  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key]?.toString().toLowerCase();
      const bValue = b[sortConfig.key]?.toString().toLowerCase();
      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });

  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} style={{ cursor: "pointer" }} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} style={{ cursor: "pointer" }} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} style={{ cursor: "pointer" }} />
    );
  };

  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);


  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}

        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <h5 className="Roles_text">Farm Operations</h5>

                    <div className="d-flex justify-content-between mt-4">
                      <div>
                        <h6 className="mb-0 Sub_role_text">Spray Service</h6>
                      </div>
                      <span
                        class="d-inline-block"
                        tabindex="0"
                        data-toggle="tooltip"
                        title="Add Product Master"
                      >
                        <Button
                          variant="primary"
                          className="buttons"
                          onClick={handleModalOpen}
                        >
                          {/* <FontAwesomeIcon
                            icon={faPlus}
                            className="plus_icon mr-1"
                          /> */}

                          <img
                            src={Add_Icon}
                            alt="Add"
                            className="addicon"
                          />
                          Add
                        </Button>
                      </span>
                    </div>
                    <div className="mcrc_hrline"></div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ paddingBottom: 20 }}
                    >
                      <div className="d-flex align-items-center">
                        <label className="mr-1">Show </label>
                        <Select
                          options={[
                            { value: 10, label: '10' },
                            { value: 20, label: '20' },
                            { value: 50, label: '50' },
                          ]}
                          value={{
                            value: itemsPerPage,
                            label: String(itemsPerPage),
                          }}
                          onChange={(selected) => {
                            setItemsPerPage(selected.value);
                            setCurrentPage(1);
                          }}
                          isSearchable={false}
                          styles={customstyles}
                        />
                        &nbsp;
                        <label> Entries</label>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="search-container">
                          <img
                            src={searchIcon}
                            alt="Search"
                            className="search-icon"
                          />
                          <input
                            type="text"
                            placeholder="Type to Search..."
                            value={searchTerm}
                            onChange={(e) => handleFilter(e.target.value)}
                            className="search-input mr-2"
                          />
                          {searchTerm && (
                            <button
                              type="button"
                              className="search-clear-btn"
                              onClick={() => handleFilter("")}
                            >
                              ×
                            </button>
                          )}
                        </div>
                        &nbsp;
                        <button
                          className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                          onClick={exportToExcel}
                        >
                          Download Excel
                        </button>
                      </div>

                    </div>
                    <div>
                      <div className="card data_tableCard">
                        <div className="card-body  ">
                          <Table className="table table-bordered  table-striped">
                            {" "}
                            <Thead>
                              <Tr>
                                <Th className="text-center">S.No</Th>

                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("newDateFormat")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Date
                                    {renderSortIcon("newDateFormat")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("sprayerName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Sprayers Name
                                    {renderSortIcon("sprayerName")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("locationName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Location
                                    {renderSortIcon("locationName")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("service")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Service
                                    {renderSortIcon("service")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("spares")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Spares
                                    {renderSortIcon("spares")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("fuel")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Fuel(in Liters)
                                    {renderSortIcon("fuel")}
                                  </span>
                                </Th>

                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("cost")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Cost
                                    {renderSortIcon("cost")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center"
                                  onClick={() => handleSort("remarks")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Remarks
                                    {renderSortIcon("remarks")}
                                  </span>
                                </Th>
                                <Th className="text-center">Actions</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {currentItems.length === 0 ? ( // Check if no data is found
                                <Tr>
                                  <Td
                                    colSpan={10}
                                    className="text-center"
                                    style={{ padding: 195 }}
                                  >
                                    Data is not available
                                  </Td>
                                </Tr>
                              ) : (
                                currentItems != undefined &&
                                currentItems != null &&
                                currentItems.map((item, index) => {
                                  var newDateFormat = moment(
                                    item.submittedDate
                                  ).format("DD-MMM-YYYY hh:mm:ss A");
                                  return (
                                    <Tr>
                                      <Td className="text-left"> {(currentPage - 1) * itemsPerPage + index + 1}</Td>
                                      <Td className="text-left">
                                        {newDateFormat}
                                      </Td>
                                      <Td className="text-left">
                                        {/* {item.sprayerId} */}
                                        {item.sprayerName}
                                      </Td>
                                      <Td className="text-left">
                                        {item.locationName}
                                      </Td>
                                      <Td className="text-left">
                                        {item.service}
                                      </Td>
                                      <Td className="text-left">
                                        {item.spares}
                                      </Td>
                                      <Td className="text-left">{item.fuel}</Td>
                                      <Td className="text-left">{item.cost}</Td>
                                      <Td className="text-right">
                                        {item.remarks}
                                      </Td>
                                      <td>
                                        <div className="d-flex justify-content-center align-items-center">
                                          <img
                                            src={Edit_Icon}
                                            alt="Edit"
                                            className="editicon mr-2"
                                            title="Edit"
                                            onClick={() => updatedItems(item)}
                                          />

                                          <img
                                            src={Delete}
                                            alt="Delete"
                                            className="deleate_icon"
                                            onClick={() => deleteItem(item)}
                                          />
                                        </div>
                                      </td>
                                    </Tr>
                                  );
                                })
                              )}
                            </Tbody>
                            {isLoading && (
                              <Loader
                                loading={isLoading}
                                message={"Fetching Data. Please Wait..!"}
                                loderimage={loaderImage}
                              />
                            )}
                          </Table>
                        </div>
                        {/* Pagination */}
                        <Pagination
                          currentPage={currentPage}
                          totalItems={sortedData.length}
                          itemsPerPage={itemsPerPage}
                          currentItems={currentItems}
                          onPageChange={handlePageClick}
                        />
                        <div>
                          <Modal
                            show={showModal}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="lg"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title> </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger  close_btn"
                                onClick={handleCancel_new}
                              >
                                {" "}
                                {/*closeWarning */}X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                <span className="modal_title">
                                  Spray Service
                                </span>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12">
                                  <label
                                    htmlFor="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Date <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <DatePicker
                                      selected={date ? parseLocalDate(date) : null}
                                      onChange={(selectedDate) =>
                                        handledateChange({
                                          target: {
                                            value: selectedDate
                                              ? `${selectedDate.getFullYear()}-${String(
                                                selectedDate.getMonth() + 1
                                              ).padStart(2, "0")}-${String(
                                                selectedDate.getDate()
                                              ).padStart(2, "0")}`
                                              : "",
                                          },
                                        })
                                      }
                                      minDate={new Date(setMinDateToToday())}
                                      dateFormat="dd-MM-yyyy"
                                      placeholderText="Select Date"
                                      customInput={
                                        <CustomDatePickerInput placeholder="Select Date" />
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6 col-12 " style={{ marginTop: "-1px" }}>
                                  <label
                                    for="InputName"
                                    className="form-label text-sm font-weight-600"
                                  >
                                    Location{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <Select
                                    inputId="dropdown"
                                    styles={modalCustomStyles}
                                    placeholder="Select Location Name"
                                    value={
                                      locationDropDownData
                                        .map((item) => ({
                                          value: item.code,
                                          label: item.name,
                                        }))
                                        .find(
                                          (option) => String(option.value) === String(selectedLocation.code)
                                        ) || null
                                    }
                                    options={locationDropDownData.map((item) => ({
                                      value: item.code,
                                      label: item.name,
                                    }))}
                                    onChange={(selectedOption) =>
                                      handlelocationChange({
                                        target: {
                                          value: selectedOption ? String(selectedOption.value) : "",
                                        },
                                      })
                                    }
                                    isClearable
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    htmlFor="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Sprayers ID <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <Select
                                    inputId="dropdown"
                                    styles={modalCustomStyles}
                                    placeholder="Select Sprayers "
                                    value={
                                      sparyerDropDownData
                                        .map((item) => ({
                                          value: item.code,
                                          label: item.name,
                                        }))
                                        .find(
                                          (option) =>
                                            String(option.value) === String(selectedSparyer.code)
                                        ) || null
                                    }
                                    options={sparyerDropDownData.map((item) => ({
                                      value: item.code,
                                      label: item.name,
                                    }))}
                                    onChange={(selectedOption) =>
                                      handleSprayersIDChange({
                                        target: {
                                          value: selectedOption ? String(selectedOption.value) : "",
                                        },
                                      })
                                    }
                                    isClearable
                                  />
                                </div>


                                <div className="col-md-6 col-12 mt-1">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 "
                                  >
                                    Service{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2 "
                                      placeholder="Service"
                                      value={serviceId}
                                      onChange={handleServiceChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600"
                                  >
                                    Spares{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>

                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2 "
                                      placeholder="Spares"
                                      value={spares}
                                      onChange={handleSparesChange}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 "
                                  >
                                    Fuel (In Liters){" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2 "
                                      placeholder="fuel"
                                      value={fuel}
                                      onChange={handlefuelChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Cost <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="number"
                                      className="form-control p-2"
                                      placeholder="Cost"
                                      value={cost}
                                      onChange={handleCostChange}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Remarks{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Remarks"
                                      value={remarks}
                                      inputMode="text"
                                      onChange={handleRemarksChange}
                                    />
                                  </div>
                                </div>
                                {error && (
                                  <span
                                    style={{ color: "red" }}
                                    className="error-message"
                                  >
                                    {error}
                                  </span>
                                )}
                              </div>{" "}
                              <br />
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  variant="primary"
                                  className="btnn"
                                  onClick={() => {
                                    setModalData({
                                      id: id,
                                      requiredDate: date,
                                      locationId: selectedLocation.code,
                                      locationName: selectedLocation.name,
                                      service: serviceId,
                                      SprayersID: selectedSparyer.code,
                                      spares: spares,
                                      fuel: fuel,
                                      cost: cost,
                                      remark: remarks,
                                      submittedDate: data,
                                      serverRecordId: "",
                                    });
                                    handleSubmit(modalData);
                                  }}
                                >
                                  {buttonText}
                                </Button>
                                <div style={{ width: "20px" }}></div>
                                <Button
                                  variant="danger"
                                  className="btnn"
                                  onClick={handleCancel_new}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Spray Service
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close the Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showResponsePopup}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">
                                  Spray Service{" "}
                                </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {submitResponse}
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleresponse}
                                >
                                  Okay
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}
          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->
        <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
      {/*  <!-- Logout Modal--> */}
      <Logout />
      {/* {!isUserLoggedIn && <Login />} */}
    </body>
  );
};

export default FarmOperationsSprayServices;
